import { Dialog, DialogContent, DialogTitle } from "../../../../ui/common-ui/dialog";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

interface ExpandedCardDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  title?: string;
}

export const ExpandedCardDialog = ({ open, onOpenChange, children, title }: ExpandedCardDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl w-[95vw] h-[90vh] p-0 border-0 bg-transparent shadow-none [&>button]:hidden overflow-hidden">
        <VisuallyHidden>
          <DialogTitle>{title || "Card Details"}</DialogTitle>
        </VisuallyHidden>
        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 20 }}
              transition={{ type: "spring", duration: 0.5, bounce: 0.2 }}
              className="relative bg-card rounded-3xl border border-border/60 shadow-[0_24px_80px_rgb(15_23_42/0.18)] overflow-hidden h-full flex flex-col"
              style={{
                WebkitFontSmoothing: 'antialiased',
                backfaceVisibility: 'hidden',
                transform: 'translateZ(0)',
              }}
            >
              {/* Close button */}
              <button
                onClick={() => onOpenChange(false)}
                className="absolute top-4 right-4 z-50 p-2 rounded-full bg-muted/80 backdrop-blur hover:bg-muted transition-colors"
              >
                <X className="w-5 h-5 text-muted-foreground" />
              </button>

              {/* Content */}
              <div className="relative p-8 flex-1 min-h-0 flex flex-col overflow-y-auto custom-scrollbar">
                {children}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </DialogContent>
    </Dialog>
  );
};
